export default "assets/images/icons/arrow_newsletter-fd0f9ece.svg";